import XmlRootComponent from './XmlRoot';
import SiteComponent from './Site';
import NodeComponent from './Node';

export const XmlRoot = XmlRootComponent;
export const Site = SiteComponent;
export const Node = NodeComponent;



// WEBPACK FOOTER //
// ./src/components/Xml/index.js